import React from 'react'
import styled from "@emotion/styled";
import {motion} from "framer-motion";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {popupShowState, popupState} from "../../../atom/simpleCert";
import Button from "../Button";

const Container = styled.div`
    height: 100%;
    width: 100%;
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 50px;
    z-index: 1000;
`;

const DimVariants = {
    init: {opacity: 0},
    open: {opacity: 1},
    exit: {opacity: 0},
};

const Dim = styled(motion.div)`
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
`;

const Box = styled(motion.div)`
    position: absolute;
    padding-bottom: 30px;
    background-color: white;
    width: calc(100% - 32px);
    height: calc(100% - 100px);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
`;

const BoxVariants = {
    init: {opacity: 0},
    open: {opacity: 1},
    exit: {opacity: 0},
};

export default function Popup() {
    const {children, confirm} = useRecoilValue(popupState);
    const setShow = useSetRecoilState(popupShowState);

    const close = () => {
        setShow(false);
    }

    const onConfirm = () => {
        close();
        if (confirm) confirm();
    }

    return (
        <Container>
            <Dim variants={DimVariants} initial="init" animate="open" exit="exit" transition={{duration: 0.1}} onClick={close}/>
            <Box variants={BoxVariants} initial="init" animate="open" exit="exit" transition={{duration: 0.1}}>
                {children}
                <Button onClick={onConfirm}> 확인 </Button>
            </Box>
        </Container>
    )
}
